import { Accordion, AccordionGroup, Box } from "@origin-digital/ods-core";
import React from "react";
import { solarBatteryOutlook as content } from "../content.json";
import { IISolarBatteryOutlookResponse } from "@/contract/generated/electrify-v1";
import { BillVision } from "@/features/SharedComponents";

export const SolarAccordion = ({
  accordionId,
  defaultExpanded,
  solarBatterySystem,
}: {
  accordionId: string;
  defaultExpanded: boolean;
  solarBatterySystem: IISolarBatteryOutlookResponse;
}) => {
  return (
    <AccordionGroup>
      <Accordion
        size={"small"}
        id={accordionId}
        defaultExpanded={defaultExpanded}
        key={accordionId}
        summary={`${content.accordion.summaryHeading}`}
      >
        <Box
          display="flex"
          marginBottom="xsmall"
          flexDirection={{ xs: "column", lg: "row" }}
        >
          <BillVision recommendationSystem={solarBatterySystem} />
        </Box>
      </Accordion>
    </AccordionGroup>
  );
};
